// =============================================================================
// HOOKS/USECURRENTUSER.TS - Usuário autenticado com papel real do backend (SPEC 1)
// =============================================================================
// Chama GET /auth/me para obter papel e ativo do banco, não só da conta MSAL.
// Necessário para: guard de rota /admin, exibição de link Admin no Header.
// =============================================================================

import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth/authConfig';
import type { PapelUsuario } from '../types';

export interface CurrentUser {
  id: string;
  email: string;
  nome: string;
  papel: PapelUsuario;
  ativo: boolean;
}

export function useCurrentUser() {
  const { instance, accounts } = useMsal();
  const [currentUser, setCurrentUser] = useState<CurrentUser | null>(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    if (!accounts.length) {
      setCarregando(false);
      return;
    }

    let cancelado = false;

    async function fetchMe() {
      try {
        const result = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
        const resp = await fetch(
          `${import.meta.env.VITE_API_URL ?? 'http://localhost:3001'}/auth/me`,
          { headers: { Authorization: `Bearer ${result.idToken}` } },
        );
        if (!resp.ok) {
          if (!cancelado) setCurrentUser(null);
          return;
        }
        const data: CurrentUser = await resp.json();
        if (!cancelado) setCurrentUser(data);
      } catch {
        if (!cancelado) setCurrentUser(null);
      } finally {
        if (!cancelado) setCarregando(false);
      }
    }

    fetchMe();
    return () => { cancelado = true; };
  }, [instance, accounts]);

  return { currentUser, carregando };
}
